import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppConfig } from "../context/AppConfigContext";
import Lottie from "lottie-react";
import maintenanceAnimation from "../assets/maintenance.json";

const MaintenancePage = () => {
  const { config } = useAppConfig();
  const maintenance = config?.maintenanceMode;

  if (!maintenance?.enabled) return null;

  const {
    title = "We’ll be right back!",
    message = "We’re doing some maintenance. Thanks for your patience.",
    subtitle = "",
    estimatedResume = "",
    showETA = false,
    backgroundColor = "#fff",
    accentColor = "#FD7762",
  } = maintenance;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor,
        zIndex: 9999,
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}>
      <Box sx={{ maxWidth: 580, width: "100%" }}>
        <Box
          sx={{
            width: "100%",
            mx: "auto",
            mb: 4,
          }}>
          <Lottie animationData={maintenanceAnimation} loop />
        </Box>

        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ color: accentColor, mb: 2 }}>
          {title}
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>

        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {subtitle}
          </Typography>
        )}

        {showETA && estimatedResume && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
            Estimated resume: {estimatedResume}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MaintenancePage;
